export const PRE_ALIGNER_DISTRACTION_SPLINT_HELP_TEXT = {
	de: `Pre-Aligner UK und Distraktionsschiene OK werden auf den eingesendeten Unterlagen erstellt.
	Abweichungen bitte unter "individuelle Kommentare" am Ende des Formulars eintragen.`,
	en: `Pre-aligner LJ and distraction splint UJ are created on the submitted documents.
	Please enter any deviations under “individual comments” at the end of the form.`
}


